import script from "./FriendApply.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendApply.vue?vue&type=script&setup=true&lang=js"

import "./FriendApply.vue?vue&type=style&index=0&id=ea250370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea250370"]])

export default __exports__